import { CausesListComponent } from './components/causes-list/causes-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CausesListComponentV3 } from './components/causes-list-v3/causes-list-v3.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgxGlideModule } from 'ngx-glide';

@NgModule({
  declarations: [
    CausesListComponent,
    CausesListComponentV3,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    NgxGlideModule
  ],
  exports: [
    CausesListComponent,
    CausesListComponentV3
  ]
})
export class CausesListModule { }
